import { BrandTabs } from "entities/pages/types";

type TabProps = {
  id: string;
  "aria-controls": string;
};

export const getTabProps = (tab: BrandTabs): TabProps => ({
  id: `module-tab-${tab}`,
  "aria-controls": `module-tabpanel-${tab}`,
});

type Tab = {
  id: BrandTabs;
  label: string;
};

export const tabs: Tab[] = [
  { id: BrandTabs.Pages, label: "Pages" },
  { id: BrandTabs.Settings, label: "Settings" },
];
